import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ILayer } from 'src/app/Store/layers.state/layers.model';
import { IPlacemark } from 'src/app/Store/placemarks.state/placemarks.model';

import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { LayerStatusPreviewComponent } from '../layer-status-preview/layer-status-preview.component';
import { ChecklistPlacemarkBalloonService } from 'src/app/tour-component/services/checklist-placemark-balloon.service';

@Component({
    selector: 'ins-checklist-placemark-balloon',
    templateUrl: './checklist-placemark-balloon.component.html',
    styleUrls: ['./checklist-placemark-balloon.component.scss'],
    imports: [PerfectScrollbarModule, LayerStatusPreviewComponent]
})
export class ChecklistPlacemarkBalloonComponent {
  public placemark: IPlacemark = null;
  public layer: ILayer;
  public position: any;
  public tableHeight = 0;
  public isFromMultipleMenu = false;
  public mouseOnTable = false;
  @ViewChild('popupElement', { static: false }) popupElement: ElementRef;
  constructor(private readonly checklistPlacemarkService: ChecklistPlacemarkBalloonService) {
    this.checklistPlacemarkService.checklistPlacemarkChange.subscribe( (res: any) => {
      const { mouseEvent, placemark, layer, position, isFromMultipleMenu } = res;
      if (mouseEvent && this.placemark && this.popupElement?.nativeElement.contains(mouseEvent.target)) {
        return;
      }
      if (this.mouseOnTable) {
        return;
      }
      this.placemark = placemark;
      this.layer = layer;
      this.position = position;
      this.isFromMultipleMenu = isFromMultipleMenu;

      if (this.placemark) {
        const validIssuesCount = this.placemark.issues.filter((issue: any) => issue != -1).length;
        this.tableHeight = Math.min(validIssuesCount, 5) * 32;
      }
    })
  }

  public mouseEnter(): void {
    this.mouseOnTable = true;
  }

  public mouseLeave(): void {
    this.mouseOnTable = false;
    this.placemark = null;
  }

  public onScroll(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
  }
}
